import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { designContent } from 'components/Wizards/schemas/shared/designContent'
import { designProject } from 'components/Wizards/schemas/shared/designProject'
import { designTopic } from 'components/Wizards/schemas/shared/designTopic'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { includeEmojis } from 'components/Wizards/schemas/shared/includeEmojis'
import { language } from 'components/Wizards/schemas/shared/language'
import { palette } from 'components/Wizards/schemas/shared/palette'
import { sourceVisualElementId } from 'components/Wizards/schemas/shared/sourceVisualElementId'
import { textStyles } from 'components/Wizards/schemas/shared/textStyles'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { StepSchema, MultiStepSchema } from 'components/Wizards/schemas/Types'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { boolean, number, object } from 'yup'
import { meta } from '../schemaCommon'
import { DesignChannel } from 'components/NewFileModal/Types'

const StartWithImageSchema = object({
  initial_media_file_id: number().default(undefined).transform(safify),
}).meta({
  title: 'Start with an image',
  supportedMediaTypes: ['image'],
}) as StepSchema

const SetupBasicsSchema = object({
  width: number().required(),
  height: number().required(),
  initial_media_file_remove_background: boolean().default(false).meta({ hidden: true }),
}).meta({
  title: 'Setup the basics',
}) as StepSchema

export const getPostDetailsSchema = ({ generationType }: { generationType: string }) =>
  object({
    topic: designTopic
      .meta({
        label: `What is it about?`,
        generate: false,
        generationType,
      })
      .required(),
    brand_kit_id: brandKitId,
    tone: tone.optional().meta({ generationType }),
    filename,
    project: designProject,
    language: language.meta({ overflow: true }),
    include_emojis: includeEmojis.meta({ overflow: true }),
  }).meta({
    title: 'Refine post details',
  }) as StepSchema

const TemplateSchema = object({
  source_visual_element_id: sourceVisualElementId,
  content: designContent,
}).meta({
  title: 'Enhance with a template',
  stepId: 'ChooseTemplate',
}) as StepSchema

export const CustomiseLayoutSchema = object({
  palette,
  text_styles: textStyles,
}).meta({
  title: 'Customize layout',
}) as StepSchema

export const FlowA1Schema = ({ generationType }: { generationType: string }) =>
  ({
    meta,
    steps: [StartWithImageSchema, SetupBasicsSchema, getPostDetailsSchema({ generationType }), TemplateSchema],
  } as MultiStepSchema<DesignChannel>)
